<div class="d-block w-100">
  <ul class="list-unstyled" id="searchFields">
    <li>
      <div class="tab w-100">
        <a #emailAddress
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == emailAddress.id}"
          id="emailAddress">Email<em class="dropdown-toggle" style="float: right"></em></a>
          <a #mobileNo
            (click)="getTabContent($event)"
            [ngClass]="{'active':activeTab == mobileNo.id}"
            id="mobileNo">Mobile<em class="dropdown-toggle" style="float: right"></em></a>
          </div>
          <form [formGroup]="form">
            <div>
              @switch (activeTab) {
                @case (emailAddress.id) {
                  <div class="tabcontent">
                    <input (input)="setSearchCriteria($event)"
                      class="form-control"
                      formControlName="email"
                      id="email"
                      placeholder="Email"
                      type="text"/>
                  </div>
                }
                @case (mobileNo.id) {
                  <div class="tabcontent">
                    <input (input)="setSearchCriteria($event)"
                      class="form-control"
                      formControlName="mobile"
                      id="mobile"
                      placeholder="Mobile"
                      type="tel"/>
                  </div>
                }
              }
            </div>
            <div class="row">
              <div [hidden]="!tabActive" class="col-md-12 text-center">
                <button (click)="clear(activeTab)"
                  [disabled]="disableClear(activeTab)"
                  class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                  type="button">
                  Clear
                </button>
                <button (click)="clearAll()"
                  [disabled]="disableClearAll()"
                  class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                  type="button">
                  Clear All
                </button>
                <button (click)="search()"
                  class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                  type="submit">
                  Update
                </button>
              </div>
            </div>
          </form>
        </li>
      </ul>
    </div>